import { render, staticRenderFns } from "./Sale-card.vue?vue&type=template&id=c530bd6c&scoped=true"
import script from "./Sale-card.vue?vue&type=script&lang=js"
export * from "./Sale-card.vue?vue&type=script&lang=js"
import style0 from "./Sale-card.vue?vue&type=style&index=0&id=c530bd6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c530bd6c",
  null
  
)

export default component.exports